import RefreshButton from '../../../../atoms/RefreshButton';
import { useConsumerSearch } from '../hooks/useConsumerSearch';
import { useRemainingHeight } from '../hooks/useRemainingHeight';
import { TopologyResource } from '../hooks/useTopology';
import ConsumerSearch from '../shared/ConsumerSearch';
import SubscriptionsEmptyState from '../shared/SubscriptionsEmptyState';
import { Section } from '../shared/ui';
import SubscriptionConfig from './SubscriptionConfig';

const CARD_BOTTOM_GAP = 40;

const ConfigTab = ({ topology }: { topology: TopologyResource }) => {
  const subscriptions = topology.data?.subscriptions ?? [];
  const { search, setSearch, visible } = useConsumerSearch(subscriptions);
  const { ref, height } = useRemainingHeight(CARD_BOTTOM_GAP);

  return (
    <Section
      title="Configuração implantada"
      subtitle="Lida da AWS: assinaturas do tópico, filter policy e raw delivery"
      actions={
        <>
          <ConsumerSearch value={search} onChange={setSearch} />
          <RefreshButton variant="icon" label="a configuração" busy={topology.loading} onClick={topology.reload} />
        </>
      }
    >
      <div ref={ref} style={{ height }} className="overflow-y-auto" data-testid="config-scroll">
        <SubscriptionsEmptyState total={subscriptions.length} visible={visible.length} />
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 2xl:grid-cols-3">
          {visible.map((subscription) => (
            <SubscriptionConfig key={subscription.subscriptionArn} subscription={subscription} />
          ))}
        </div>
      </div>
    </Section>
  );
};

export default ConfigTab;
